/*
 * @Description: app 交互js
 * @Author: zhuzhida
 * @Date: 2019-08-08 16:22:19
 * @LastEditTime: 2019-08-14 14:30:59
 * @LastEditors: Please set LastEditors
 */
const AppHelper = (function () {
  /*
      app 调用规则
    */
  function executed (name, data) {
    let params = { name, data }
    let str = JSON.stringify(params)
    console.info('调用app参数输出', str)
    var _window = window
    let _userAgent = navigator.userAgent
    console.log('app userAgent 输出', _userAgent)
    // smart-counselor/android         smart-counselor/ios
    if (_userAgent.indexOf('smart-counselor/android') !== -1) {
      console.log('调用android')
      try { _window.callApp.postMessage(str) } catch (error) { alert('android error :' + JSON.stringify(error) + 'post android str :' + str) }
    } else if (_userAgent.indexOf('smart-counselor/ios') !== -1) {
      console.log('调用ios')
      try { _window.webkit.messageHandlers.callApp.postMessage(str) } catch (error) { alert('ios error :' + JSON.stringify(error) + 'post ios str :' + str) }
    }
  }

  return {
    /* 1.在app中打开新WebView */
    openWebView (data = {
      'url': 'https://www.baidu.com', // 要跳转的url,
      'title': '', // 页面标题
      'showShare': '' // 是否在app右上角显示分享按钮  true false
    }) {
      executed('newWebView', data)
    },
    /* 2.分享 */
    share (data = {
      title: '分享标题',
      content: '分享内容',
      image: 'http://img6.pengfu.cn/middle/190/710190.jpg',
      url: 'https://www.baidu.com',
      isNotifyApiState: false, // 是否需要上报
      type: 0// 0全部 1微信聊天 2 朋友圈
    }) {
      executed('share', data)
    },
    /* 3.打开PC登录 */
    openPCLogin (data = { 'taskId': 'sfsdfsdfasdf' }) {
      executed('QrCode', data)
    },
    /* 4.打开学生详情（参数不确定） */
    openStudentDetails (data = { resourceid: 0 }) {
      executed('studentDetails', data)
    },
    /* 5.打开院校详情 */
    openSchoolDetails (data = { 'schoolId': '1' }) {
      executed('schoolDetails', data)
    },
    /* 6.打开二级选择页面  Type参数说明：1、选校建议  2、时间规划   3、基本信息   4、留学意向   5、选择优惠券 */
    openChooseView (data = { 'taskId': '1', 'type': '1' }) {
      executed('chooseView', data)
    },
    /* 7.App返回 */
    back () {
      executed('goback', {})
    },
    /* 8.作废合同 连续返回两次（制作合同，直接返回到学生列表） */
    openStudentList () {
      executed('twiceGoback', {})
    },
    // 8.1 顾问端认证平台顾问（选择顾问类型的页面）
    opencertification () {
      executed('certificationAdviser', {})
    },

    /* 9.打开留学方案
      @param resourceId 资源ID
      @param studentName 学生姓名
      @param userName 顾问姓名
    */
    openSchemeDetail (data = {
      'resourceId': '',
      'studentName': ''
    }) {
      executed('planProgramme', data)
    },
    /* 10.打开 签约成功列表页 */
    openInviteFriend () {
      executed('inviteFriendsList', {})
    },
    /**
     * 11.调起app登录
     */
    openLogin () {
      executed('login', {})
    },
    // 12.学生端订单支付  1、orderNum订单号 2、serni_no潜在编号 3、r_no资源号 4、contractID合同ID  5、contractFee 合同费用 6、contractAgio优惠金额 7、contractPay 已支付金额
    payOrder (data = {
      'orderNum': '',
      'serni_no': '',
      'r_no': '',
      'contractID': '',
      'contractFee': '',
      'contractAgio': '',
      'contractPay': ''
    }) {
      executed('pay', data)
    },
    // 13.查看电子收据
    seekElectronicReceipt (data = {
      'resourceNo': ''
    }) {
      executed('electronicReceipt', data)
    },
    // 14.查看顾问主页
    seekCounselorDetails (data = {
      'memberId': '',
      'articleId': ''
    }) {
      executed('counselorDetail', data)
    },
    // 15.打开委托人信息页
    openConsignorInfo (data = {
      'orderCode': ''
    }) {
      executed('consignorInfo', data)
    },
    // 16.调拨号盘
    openDial (data = {
      'phone': ''
    }) {
      executed('callPhone', data)
    },
    // 顾问端17.打开签约的产品
    openSignProduct (data = {
      'skuCode': '',
      'countryId': '',
      'countryName': '',
      'contractTypeId': ''
    }) {
      executed('signProduct', data)
    },
    // 顾问端18.打开录名片
    openBusinessCard (data = {}) {
      executed('businessCard', data)
    },
    // 顾问端20 进入抢单列表页面
    grabList (data = {}) {
      executed('grabSingle', data)
    },
    // 顾问端21 返回首页拉起精选产品筛选页面
    backHomeOrder (data = {}) {
      executed('popHomeOrder', data)
    },
    // 顾问端22 关闭app内的分享按钮
    hiddenShare (data = {}) {
      executed('hiddenShare', data)
    },
    // 顾问端23 显示app内的分享按钮
    showShare (data = {
      'name': 'showShare',
      'data': {
        'title': 'title ',
        'content': 'content ',
        'image': 'image ',
        'url': 'url ',
        'type': 0, // 0全部 1微信聊天 2 朋友圈
        'isNotifyApiState': true // 是否需要掉上报接口
      }
    }) {
      executed('showShare', data)
    },
    // 学生端访问顾问列表
    myCounselorList (data = {}) {
      executed('myCounselorList', data)
    },
    // 进入待办任务
    pendingTask (data = {}) {
      executed('pendingTask', data)
    },
    // 进入录学生
    inputStudent (data = {}) {
      executed('inputStudent', data)
    },
    // 进入联系客服
    linkCustomer (data = {}) {
      executed('linkCustomer', data)
    },
    // 学生端取消订单
    orderCancle (data = {}) {
      executed('orderCancle', data)
    },
    // 学生端打开语言课程 1--留学产品 5--精品课程 9--移民置业 15--DIY留学
    openCourses (data = {}) {
      executed('openStudyAbroadProduct', data)
    },
    // 学生端打开扫描二维码
    openScanningCode (data = {}) {
      executed('openQrCode', data)
    },
    // 学生端获取定位
    getLocation (data = {}) {
      executed('getLocation', data)
    },
    // 学生端获取公共参数
    getPublicParameters (data = {}) {
      executed('getPublicParameters', data)
    },
    // 顾问端获取学生列表
    getStudentList (data = {}) {
      executed('openRouter', data)
    },
    // 学生端添加直播日历
    addCalendar (data = {}) {
      executed('liveAddCalendar', data)
    },
    // 打开顾问端内原生页面方法
    // {
    //     "name":" openRouter",
    //     "data":{
    //         "router":"Activity://StudyFragment/init?type=9"
    //     }
    // }
    openRouter (data = {}) {
      executed('openRouter', data)
    }
  }
}())

export default {
  install: function (vm) {
    vm.prototype.$AppHelper = AppHelper
  },
  AppHelper: AppHelper
}



// WEBPACK FOOTER //
// ./src/util/appHybrid.js